import { byAttrVal, createCustomElement, DOMModel, registerEvent } from '@adobe/react-webcomponent'
import { ModalContextProvider } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { QueryClientProvider } from 'react-query'
import { BrowserRouter as Router } from 'react-router'

import { UserOrganizationContextProvider } from '@modules-deprecated/app/organization'
import { CurrentUserContextProvider } from '@modules-deprecated/app/user'
import { AcceptAllMatchSuggestions } from '@views/reconciliation/elements/AcceptAllMatchSuggestions'
import { AcceptAllMatchSuggestionsContextProvider } from '@views/reconciliation/elements/AcceptAllMatchSuggestions/contexts/acceptAllMatchSuggestionsContext'

import { queryClient } from '../../config/queryClient'
import { ThemeProvider } from '../../contexts/themeProvider'
import { EmberEventFn } from '../../types/emberEventFn'

class BankAcceptAllMatchSuggestionsButtonWebComponent extends DOMModel {
  @byAttrVal arematchesloaded: string
  @byAttrVal matchsuggestions: string
  @byAttrVal organizationId: string
  @registerEvent('removeMatches') removeMatches: EmberEventFn
}

type BankAcceptAllMatchSuggestionsButtonModuleProps = {
  arematchesloaded: string
  matchsuggestions: string
  organizationId: string
  onRemoveMatches: EmberEventFn
}

function BankAcceptAllMatchSuggestionsButtonModule({
  arematchesloaded,
  matchsuggestions,
  organizationId,
  onRemoveMatches,
}: BankAcceptAllMatchSuggestionsButtonModuleProps): ReactElement {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <Router>
          <UserOrganizationContextProvider organizationId={organizationId}>
            <CurrentUserContextProvider>
              <ModalContextProvider>
                <AcceptAllMatchSuggestionsContextProvider
                  areMatchesLoaded={arematchesloaded}
                  matchSuggestions={matchsuggestions}
                  removeMatches={onRemoveMatches}
                >
                  <AcceptAllMatchSuggestions />
                </AcceptAllMatchSuggestionsContextProvider>
              </ModalContextProvider>
            </CurrentUserContextProvider>
          </UserOrganizationContextProvider>
        </Router>
      </QueryClientProvider>
    </ThemeProvider>
  )
}

const BankAcceptAllMatchSuggestionsButtonCustomElement = createCustomElement(
  BankAcceptAllMatchSuggestionsButtonModule,
  BankAcceptAllMatchSuggestionsButtonWebComponent,
  'element',
)

customElements.get('bank-accept-all-match-suggestions') ||
  customElements.define('bank-accept-all-match-suggestions', BankAcceptAllMatchSuggestionsButtonCustomElement)

export default BankAcceptAllMatchSuggestionsButtonCustomElement
